<template>
  <div style="height: 100%">
    <RegisterContainer
      style="height: 100%"
      :contentStyle="{ height: '100%', position: 'relative' }"
    >
      <div style="position: absolute; inset: 0; z-index: 2" v-if="createLabReq">
        <TruformeLabReq @success="labReqCreated = true" :partnerId="partnerId" />
      </div>
      <div
        style="
          margin: auto;

          position: absolute;
          inset: 0;

          max-height: 100%;
          overflow: auto;
          background-color: var(--v-background-base);
          z-index: 1;
        "
        class="pa-2 text-center flex-grow-1 d-flex justify-center align-center"
      >
        <TruformeLoader> Finishing up... </TruformeLoader>
      </div>
      <div
        style="position: absolute; display: flex; justify-content: center"
        v-if="createPrescription"
      >
        <PrescriptionPad @success="prescriptionCreated = true" :partnerId="partnerId" />
      </div>
    </RegisterContainer>
  </div>
</template>
<style>
.hide-prescription {
  transform: translateY(-1000px);
}
</style>
<script>
import PrescriptionPad from '../components/PrescriptionPad.vue';
import RegisterContainer from '../components/RegisterContainer.vue';
import TruformeLoader from '../components/Truforme/TruformeLoader.vue';
import TruformeLabReq from '../components/Truforme/TruformeLabReq.vue';

export default {
  name: 'TruformeGeneratePrescription',
  props: {
    customLogo: String,
  },
  components: { PrescriptionPad, RegisterContainer, TruformeLoader, TruformeLabReq },
  data() {
    return {
      createPrescription: false,
      createLabReq: false,
      prescriptionCreated: false,
      labReqCreated: false,
      nextRoute: null,
      showDialog: true,
      thankyouDialog: true,
      /* tenant customizable options */
      buttonText: this.$t('registration.registerComplete.buttonText'),
      clickToContinue: true,
      cardText: this.$t('registration.registerComplete.cardText'),
      cardTitle: this.$t('registration.registerComplete.cardTitle'),
      loadingText: null,
      loadingTitleText: null,
      init: null,
      /* should the store be reset after this component completes */
      isEndOfRegistration: true,
      checkForExistingUser: false,
      sendNotification: true,
      onSuccess: () => {},
    };
  },

  computed: {
    partnerId() {
      return this.$route.query?.partnerId;
    },
    isComplete() {
      const pres = !this.createPrescription || this.prescriptionCreated;
      const lab = !this.createLabReq || this.labReqCreated;
      return pres && lab;
    },
    memberId() {
      return this.$store.state.registration.memberId;
    },
    saveText() {
      return this.$store.state.registration.saveText;
    },
    loadingValue() {
      return this.$store.state.loadingValue;
    },
  },
  watch: {
    isComplete(val) {
      if (!val) return;
      window.dispatchEvent(new CustomEvent('GO_NEXT_PAGE'));
    },
  },
};
</script>
